import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const actionType = {
	SetOrgano: '[ORGANOS] SET_ORGANS',
};


const initialState = {
	organs: [],
};

export const reducer = persistReducer(
	{ storage, key: 'organsByRole', whitelist: ["organs"] },
	(state = initialState, action) => {
		switch (action.type) {
			case actionType.SetOrgano:
				return { ...state, organs: action.payload };

			default:
				return state;
		}
	}
);

export const organsAction = {
	setOrganosByRole: (data) => ({
		type: actionType.SetOrgano,
		payload: data,
	}),
};
